import * as React from "react";

import { cx } from "@/components/ui/controlStyles";

// The page frame inside the customer shell's content column.
//
//   list   centred, max 1440px, page gutter (16px, 32px from md) — lists,
//          dashboards, most pages
//   narrow centred, max 880px — settings, forms, single-column reading
//   flush  full-bleed, no padding — master-detail, canvases, chat
//
// list / narrow own their vertical scroll (the shell's column is a fixed
// height); pass scroll={false} when the page manages it.
//
// Inside the phone companion (<body class="companion">) the top padding
// drops to 4px, the inset every companion screen uses under its "‹ More"
// bar, so a hosted page's title sits where Projects' and Deliverables' do.

interface PageContainerProps {
  variant?: "list" | "narrow" | "flush";
  scroll?: boolean;
  children: React.ReactNode;
  className?: string;
  /** Classes for the scrolling outer box. */
  outerClassName?: string;
}

export function PageContainer({
  variant = "list",
  scroll = true,
  children,
  className,
  outerClassName,
}: PageContainerProps) {
  if (variant === "flush") {
    return <div className={cx("flex h-full min-h-0 flex-col", className)}>{children}</div>;
  }
  return (
    <div className={cx("h-full min-h-0", scroll && "overflow-y-auto", outerClassName)}>
      <div
        className={cx(
          "mx-auto w-full px-4 py-6 md:px-8 md:py-8 [.companion_&]:pt-1",
          variant === "narrow" ? "max-w-[880px]" : "max-w-[1440px]",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
